<template>
    <div>
        <div v-if="!data.length" class="lego-manual-box__row empty">
            Props is not provided.
        </div>
        <template v-for="(item, idx) in data">
            <div v-if="!item.hide" class="lego-manual-box__row">
                <div class="lego-manual-box__left-area">
                    <div class="lego-manual-box__item name">
                        <div class="lego-manual-box__item__label">Name</div>
                        <div class="lego-manual-box__item__value">
                            {{item.name}} <span v-if="item.abbr">(= {{item.abbr}})</span>
                        </div>
                    </div>
                    <!-- <div class="lego-manual-box__item tag">
                        <div class="lego-manual-box__item__label">Tag</div>
                        <div class="lego-manual-box__item__value">
                            <div v-if="item.required" class="lego-manual-box__item__value__badge required">required</div>
                            <template v-for="(tag, idx) in item.tags">
                                <div class="lego-manual-box__item__value__badge">{{tag}}</div>
                            </template>
                        </div>
                    </div> -->
                </div>
                <div class="lego-manual-box__right-area">
                    <div class="lego-manual-box__item type">
                        <div class="lego-manual-box__item__label">Type</div>
                        <div class="lego-manual-box__item__value">{{item.type||'Any'}}</div>
                    </div>
                    <div class="lego-manual-box__item default">
                        <div class="lego-manual-box__item__label">Default</div>
                        <div class="lego-manual-box__item__value" v-if="item.default!==undefined">
                            <pre><code>{{item.default}}</code></pre>
                        </div>
                        <div class="lego-manual-box__item__value--undefined" v-else>undefined</div>
                    </div>

                    <div class="lego-manual-box__item description">
                        <div class="lego-manual-box__item__label">Description</div>
                        <div class="lego-manual-box__item__value" v-if="lang==='ko'" v-html="item.describe" ></div>
                        <div class="lego-manual-box__item__value" v-if="lang==='en'" v-html="item.describeEn || item.describe" ></div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>


<script>
export default {
    props: {
        data: {
            type:Array,
            default: function () {
                return [];
            }
        },
        lang: {type:String,default:'ko'}
    }
}
</script>


<style lang="scss">
.lego-manual-box__item.default {
  pre {overflow: auto;margin-top:5px;}
  code {font-family: d2Coding, Consolas, dotum, "돋움", sans-serif;
    font-size: 14px;color:#444;line-height: 150%;word-break: break-all;white-space: pre-line;}
}
</style>